import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "level", "drawingStyle", "colorTheme", "size", "disabled", "startIcon", "endIcon", "loading", "type", "onClick", "labelHidden", "tabIndex"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { EmbersLoading } from '../loading/loading';
import { createButtonTheme, BUTTON_ROOT_PREFIX } from './buttonStyles';
export var EmbersButton = function EmbersButton(props) {
  var _classnames;
  var className = props.className,
    children = props.children,
    _props$level = props.level,
    level = _props$level === void 0 ? 'primary' : _props$level,
    _props$drawingStyle = props.drawingStyle,
    drawingStyle = _props$drawingStyle === void 0 ? 'filled' : _props$drawingStyle,
    _props$colorTheme = props.colorTheme,
    colorTheme = _props$colorTheme === void 0 ? 'purple' : _props$colorTheme,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    disabled = props.disabled,
    startIcon = props.startIcon,
    endIcon = props.endIcon,
    loading = props.loading,
    type = props.type,
    onClick = props.onClick,
    labelHidden = props.labelHidden,
    tabIndex = props.tabIndex,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = createButtonTheme();

  // startIcon
  var buttonStartIcon = startIcon;
  if (!startIcon && loading) {
    buttonStartIcon = /*#__PURE__*/React.createElement(EmbersLoading, {
      "aria-hidden": true,
      size: size === 'small' ? 16 : 'small'
    });
  }

  // validation
  var validatedLevel = level;
  if (drawingStyle === 'text') {
    validatedLevel = 'tertiary';
  } else if (drawingStyle === 'tonal') {
    validatedLevel = 'secondary';
  }

  // MUI uses "variant" for a slightly different schema
  var muiVariant;
  if (drawingStyle === 'text') {
    muiVariant = 'text';
  } else if (drawingStyle === 'outlined') {
    muiVariant = 'outlined';
  } else {
    // both "filled" and "tonal" are "contained" for mui's purposes
    muiVariant = 'contained';
  }

  // MUI uses "color" for a slightly different schema
  var muiType;
  if (level === 'tertiary') {
    muiType = 'info';
  } else if (level === 'secondary') {
    muiType = 'secondary';
  } else {
    muiType = 'primary';
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Button, _extends({
    tabIndex: disabled || loading ? -1 : tabIndex || 0,
    "aria-label": labelHidden ? children : void 0 // prevents readout of icon and reads hidden label when icon only
    ,
    "aria-busy": loading ? 'true' : 'false',
    variant: muiVariant,
    disableRipple: true,
    size: size,
    color: muiType,
    disabled: disabled,
    startIcon: buttonStartIcon,
    endIcon: endIcon,
    className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-root"), true), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-hasStartIcon"), buttonStartIcon), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-hasEndIcon"), endIcon), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-").concat(validatedLevel, "Level"), true), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-").concat(colorTheme, "Color"), true), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-").concat(drawingStyle, "DrawingStyle"), true), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-hasStartIcon-loading"), loading), _defineProperty(_classnames, "".concat(BUTTON_ROOT_PREFIX, "-icon-only"), labelHidden || !children), _classnames), className),
    type: loading ? 'button' : type,
    onClick: !loading ? onClick : void 0
  }, otherProps), !labelHidden && children));
};